import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { OverwriteFolderPermissionsComponent } from "./overwrite-folder-permissions.component";

const routes: Routes = [
  {
    path: "",
    component: OverwriteFolderPermissionsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OverwriteFolderPermissionsRoutingModule {}
